export default {
  name: 'SavedCardsMixin',
  methods: {
    getCardIcon(card) {
      if (this.card) {
        let iconString = 'fab';
        if (card.brand.toLowerCase() == 'visa' || card.brand.toLowerCase() == 'mastercard') {
          return `${iconString} fa-cc-${card.brand.toLowerCase()}`;
        } else if (card.brand.toLowerCase() == 'amex' || card.brand.toLowerCase() == 'american express') {
          return `${iconString} fa-cc-amex`;
        } else {
          return 'fal fa-credit-card';
        }
      }
    },

    matchSelected(card, selected = this.selected) {
      if (this.selected || selected) {
        return (
          card.fingerprint == selected.fingerprint &&
          card.last4 == selected.last4 &&
          card.exp_month == selected.exp_month &&
          card.exp_year == selected.exp_year
        );
      }
    },
    savedCardDescExpiryDateSort(cardA, cardB) {
      return cardB.exp_year - cardA.exp_year;
    },
    removeExpiredCardsFilter(card) {
      return !this.cardIsExpired(card);
    },
    cardIsExpired(card) {
      if (this.currentYear > card.exp_year) {
        return true;
      } else if (this.currentYear == card.exp_year) {
        if (this.currentMonth > card.exp_month) {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  computed: {
    currentMonth() {
      let date = new Date();
      return date.getMonth() + 1;
    },
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    },
    expired() {
      return this.cardIsExpired(this.card);
    }
  }
};
